import axiosInstance from "../../translator";
import { vmInsight } from "../../constants/apis/apiEndpoints";
import { appendParam } from "../../utils";

export const getVmInsightListApi = async (params) => {
  return axiosInstance
    .get(`${vmInsight?.getVmInsightEndPoint}`, { params })
    .then((response) => {
      return {
        data: response?.data?.results,
        status: response?.status,
        count: response?.data?.count,
      };
    })
    .catch((error) => {
      return error;
    });
};

export const getVmInsightDetailsApi = async (params) => {
  return axiosInstance
    .get(`${vmInsight?.getVmInsightsDetails}${params}`)
    .then((response) => {
      return {
        data: response?.data,
        status: response?.status,
      };
    })
    .catch((error) => {
      return error;
    });
};

export const getVmInsightReportApi = async (vm_name) => {
  return axiosInstance
    .get(`${vmInsight?.getVmInsightsDetails}?vm_name=${vm_name}&response_format=csv`)
    .then((response) => {
      return {
        data: response?.data,
        status: response?.status,
      };
    })
    .catch((error) => {
      return error;
    });
};

export const getTenantListForVm = async () => {
  let params = appendParam("", "pagination", -1);
  params = appendParam(params, "flag", true);

  return axiosInstance
    .get(`${vmInsight?.vmTenantsList}${params}`)
    .then((response) => {
      let tenantList = response?.data?.results?.map?.((dt) => {
        return {
          ...dt,
          value: dt?.id,
          label: dt?.tenant_name,
        };
      });

      let responseObj = {
        data: tenantList,
        count: response?.data?.count,
        status: response?.status,
      };
      return responseObj;
    })
    .catch((error) => {
      return error;
    });
};

export const getUserListForVm = async (id) => {
  let url = `${vmInsight?.tenantBasedUsers}${id}`;
  let params = appendParam(url, "pagination", -1);

  return axiosInstance
    .get(`${params}`)
    .then((response) => {
      let userList = response?.data?.results?.map?.((dt) => {
        return {
          ...dt,
          value: dt?.id,
          label: `${dt?.first_name} ${dt?.last_name}`,
        };
      });

      return {
        data: userList,
        status: response?.status,
      };
    })
    .catch((error) => {
      return error;
    });
};
